// extracted by mini-css-extract-plugin
module.exports = {"chips":"common_carousel-module__chips--2sRW1","wrapper":"common_carousel-module__wrapper--jKhpk","inner":"common_carousel-module__inner--RyMi9"};